import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { List } from 'immutable';

import { request as getMultiples } from '../../../modules/liabilities/actions/multiples';
import { request as getMultiplesDetails } from '../../../modules/liabilities/actions/multiples-line-details';

import Multiples from './Multiples.jsx';

function mapStateToProps(state) {
    return {
        lines: state.liabilities.getIn([ 'multiples', 'items' ]) || List(),
        status: state.liabilities.getIn([ 'multiples', 'status' ], 'FINISHED' ),

        multiplesDetails: state.liabilities.getIn([ 'multiplesDetails', 'items' ]) || List(),
        multiplesDetailsStatus: state.liabilities.getIn([ 'multiplesDetails', 'status' ], 'FINISHED')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getMultiples() {
            dispatch(getMultiples());
        },
        getMultiplesDetails(selectionsIds) {
            dispatch(getMultiplesDetails(selectionsIds));
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    Multiples
);
